import "./TextArea.css";

export const TextArea = ({
  label,
  name,
  value,
  onChange,
  placeholder = "",
  error,
  minLength = 0,
  maxLength = 500,
  rows = 12,
}) => {
  return (
    <div className="textAreaWrapper">
      {label && (
        <label className="textAreaLabel" htmlFor={name}>{label}</label>
      )}
      <div className="textWrapper">
        <textarea
          name={name}
          rows={rows}
          className="textArea"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          maxLength={maxLength}
          minLength={minLength}
        />
        <div className="textAreaCounter">
          {value?.length || 0}/{maxLength}
        </div>
        {error && <div className="textAreaError">{error}</div>}
      </div>
    </div>
  );
};
